import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface FieldDocument {
  name: string;
  api_token: string;
}

export interface FieldDocumentDetaiInfor {
  errors: unknown;
  FieldDocument: FieldDocument;
  isAuthenticated: boolean;
}

@Module
export default class FieldDocumentDetail
  extends VuexModule
  implements FieldDocumentDetaiInfor
{
  errors = {};
  FieldDocument = {} as FieldDocument;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get FieldDocumentDetail() {
    return this.fieldDocumentDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.FIELD_DOCUMENT_DETAIL_DATA](FieldDocument) {
    this.fieldDocumentDetailData = FieldDocument;
  }
  @Action
  [Actions.FIELD_DOCUMENT_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/field_document",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.FIELD_DOCUMENT_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
